import * as React from 'react';
import styled from 'styled-components';
import { COLOURS } from '../../consts/style';
import { DangerousHtml } from '../DangerousHtml';

const DisclaimerWrap = styled.div.attrs({ id: 'disclaimer' })`
  box-sizing: border-box;
  padding-bottom: 28px;
  padding-top: 44px;
  color: ${COLOURS.PRIMARY.GREY};

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Disclaimer = ({ children }) => (
  <DisclaimerWrap>
    <DangerousHtml html={children} />
  </DisclaimerWrap>
);
